"use strict";
// 입고/재고 (api·web·admin 공통)
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUANTITY_MAX_DECIMALS = exports.INTEGER_ONLY_UNITS = exports.UNIT_LABELS = exports.UNIT_TYPES = exports.LOT_NO_PREFIX = exports.STOCK_IN_NO_PREFIX = exports.STOCK_MOVEMENT_TYPE_VALUES = exports.STOCK_MOVEMENT_TYPES = exports.STOCK_IN_STATUS = void 0;
exports.isIntegerOnlyUnit = isIntegerOnlyUnit;
exports.getQuantityUnitViolation = getQuantityUnitViolation;
// 입고 상태 — 확정된 입고는 삭제하지 않고 CANCELLED 로만 되돌린다
exports.STOCK_IN_STATUS = {
    CONFIRMED: "CONFIRMED",
    CANCELLED: "CANCELLED",
};
// 재고 변경 이력 유형
exports.STOCK_MOVEMENT_TYPES = {
    IN: "IN", // 입고
    IN_CANCEL: "IN_CANCEL", // 입고 취소 (원거래 참조)
    ADJUST: "ADJUST", // 수량 정정
    CONSUME: "CONSUME", // 발주 자재 사용 (실사용 차감)
};
exports.STOCK_MOVEMENT_TYPE_VALUES = Object.values(exports.STOCK_MOVEMENT_TYPES);
// 내부 추적 번호 접두사 (예: IN-20261001-000001, LOT-20261001-000001)
exports.STOCK_IN_NO_PREFIX = "IN";
exports.LOT_NO_PREFIX = "LOT";
// 기준 단위 표준 선택값
exports.UNIT_TYPES = ["M", "YD", "KG", "EA", "ROLL", "BOX"];
exports.UNIT_LABELS = {
    M: "M (미터)",
    YD: "YD (야드)",
    KG: "KG (킬로그램)",
    EA: "EA (개)",
    ROLL: "ROLL (롤)",
    BOX: "BOX (박스)",
};
// 소수 수량 정책 — EA(개수) 단위는 정수만 허용, 그 외 단위는 소수 3자리까지 허용
exports.INTEGER_ONLY_UNITS = ["EA"];
exports.QUANTITY_MAX_DECIMALS = 3;
function isIntegerOnlyUnit(unit) {
    return exports.INTEGER_ONLY_UNITS.includes((unit ?? "").trim().toUpperCase());
}
/** 단위별 수량 정책 위반 사유 (문제 없으면 null). 서버·화면 공용 */
function getQuantityUnitViolation(unit, quantity) {
    const text = String(quantity);
    if (isIntegerOnlyUnit(unit)) {
        return /^-?\d+(\.0+)?$/.test(text)
            ? null
            : `${unit?.toUpperCase()} 단위는 소수 수량을 허용하지 않습니다. 정수로 입력해주세요.`;
    }
    return null;
}
